import {CommonModule} from '@angular/common';
import {NgModule} from '@angular/core';
import {FormsModule} from '@angular/forms';

import {ExportRoutingModule} from './export-routing.module';

import {LeadaDatepickerModule} from 'shared/leada-datepicker/leada-datepicker.module';
import {ExportComponent} from './export.component';
import {ExportRepository} from './repositories/export.repository';
import {ExportService} from './services/export.service';
import {TargetGroupAnalyticsComponent} from './components/target-group-analytics/target-group-analytics.component';
import {AnalyticsResultComponent} from './components/analytics-result/analytics-result.component';
import {TargetGroupAnalyticsService} from './services/target-group-analytics.service';
import {TargetGroupAnalyticsRepository} from './repositories/target-group-analytics.repository';

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    ExportRoutingModule,
    LeadaDatepickerModule,
  ],
  declarations: [
    ExportComponent,
    TargetGroupAnalyticsComponent,
    AnalyticsResultComponent,
  ],
  providers: [
    ExportService,
    ExportRepository,
    TargetGroupAnalyticsService,
    TargetGroupAnalyticsRepository,
  ],
})

export class ExportModule { }



// WEBPACK FOOTER //
// /usr/src/app/src/app/modules/export/export.module.ts